<!-- SharingHistoryTable.vue -->
<script lang="ts" setup>
import { computed, onBeforeMount, reactive, ref } from 'vue';
import { ISurescriptsDocumentShareEvent } from '../../lib/Api/SurescriptsRecordLocator';
import * as choiceApi from '../../lib/ChoiceApi'
import { popAlert } from '../../lib/Notification';
import ChoiceTable from '../../components/ChoiceTable.vue';
import { ICol, RenderModeType } from '../../lib/ChoiceTableHelpers';
import AlertSection from '../../components/Messages/AlertSection.vue';
import { DisplayStyle, ButtonDisplayStyle } from '../../Enums/UiEnums';
import ActionButtonV2 from '../../components/ActionButtonV2.vue';
import { ActionButtonStyle  } from '../../lib/Types/Types'
import LoadingSection from '../../components/LoadingSection.vue';
import { DatabaseIdTypes } from '../../Enums/ChoiceEnums';

    const props = defineProps<{
        patientId: number
    }>();

    const emits = defineEmits<{
        (e: "viewDocument", shareEventInfo: ISurescriptsDocumentShareEvent): void
    }>();

    const compData = reactive<{
        loadingHistoryData?: boolean,
        sharingHistoryData?: ISurescriptsDocumentShareEvent[],
        sharingHistoryNextCursor?: number
    }>({
        loadingHistoryData: false
    });

    const tableColumns = ref<ICol[]>([
        {Name: "Requested By", DataField: "originiatorOrgName"},
        {Name: "Date", DataField: "postDateUtc", RenderMode: RenderModeType.DateTime},
        {Name: "Action", ExtraData: { actionCol: true} },
    ]);

    onBeforeMount(async () => {
        compData.loadingHistoryData = true;
        const resp = await choiceApi.surescriptsRLE.getSharingHistory(props.patientId, compData.sharingHistoryNextCursor);
        compData.loadingHistoryData = false;
        if (!resp)
        {
            popAlert("Error getting sharing history data");
            return;
        }
        compData.sharingHistoryData = resp.data;
        compData.sharingHistoryNextCursor = resp.cursor;
    });

    async function showDocument(shareEventInfo: ISurescriptsDocumentShareEvent): Promise<void>
    {
        emits("viewDocument", shareEventInfo);
    }

</script>

<template>
    <LoadingSection :isLoading="compData.loadingHistoryData" loadingMsg="Loading sharing history..."/>

    <template v-if="!compData.loadingHistoryData">
        <AlertSection :displayStyle="DisplayStyle.Warning" v-if="!compData.sharingHistoryData">
            None of the documents have been shared.
        </AlertSection>    
    
        <ChoiceTable 
            v-if="compData.sharingHistoryData"
            :columns="tableColumns" 
            :data="compData.sharingHistoryData">
            <template #cell="{col, row, value}">
                <template v-if="col.ExtraData?.actionCol">
                    <ActionButtonV2 :action="ActionButtonStyle.NoIcon" :performAction="() => showDocument(row)" :displayStyle="ButtonDisplayStyle.TextPrimary">
                        View Document
                    </ActionButtonV2>                
                </template>
            </template>
        </ChoiceTable>
    </template>

</template>